enum EmailEventCalendar {
    Google = '1',
    iOS = '2',
    Outlook = '3',
    Office = '4'
}

export default EmailEventCalendar;